import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import { experiences } from "@/mocks/siteData";
import { openFarms } from "@/mocks/farms";
import { useKonaseemaGuide } from "@/hooks/usePublicGuide";

export default function TripHero() {
  const { seasons } = useKonaseemaGuide();
  const stats = [
    { value: `${experiences.length}`, label: "Experiences" },
    { value: `${openFarms.length}`, label: "Farms to Visit" },
    { value: "3", label: "Ready-Made Itineraries" },
    { value: `${seasons.length}`, label: "Seasons to Choose" },
  ];

  return (
    <section className="relative min-h-[68vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Sweeping%20aerial%20view%20of%20the%20Godavari%20delta%20at%20sunrise%20with%20patchwork%20paddy%20fields%2C%20coconut%20groves%2C%20winding%20canals%20and%20a%20small%20village%20path%2C%20painterly%20stylized%20earthy%20green%20and%20fresh%20tones%2C%20cinematic%20rural%20Indian%20panorama%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=plan-trip-hero&orientation=landscape"
          width={1920}
          height={1080}
          alt="Aerial view of the Godavari delta at sunrise"
          title="Plan your trip to Konaseema with Rythugaru"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Plan Your Trip</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            Trip Planner
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Build Your Own <span className="italic text-accent-300">Delta Journey.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          Farms, experiences and the Konaseema guide — all in one place. Start from a ready-made
          itinerary or mix and match your own, day by day.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mt-10">
          <a
            href="#trip-builder"
            className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Building
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#trip-presets"
            className="inline-flex items-center justify-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse Itineraries
            <i className="ri-route-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-12 max-w-4xl">
          {stats.map((stat) => (
            <div key={stat.label} className="border-l-2 border-accent-500/70 pl-4">
              <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-background-200 mt-1 leading-snug">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}